import { featuresExtraFields } from '../../../../components/snippets/AttributeIcon';
import { deliveryMethodExtraFields } from '../../../../components/snippets/deliveryMethod/deliveryMethodIcon';
import { fundingSourceExtraFields } from '../../../../components/snippets/paymentMethodIcon';

export const decisionTaggingExtraFields = [
  ...featuresExtraFields,
  ...deliveryMethodExtraFields,
  ...fundingSourceExtraFields,
  'payment.paymentApprovalActionReason',
  'payment.riskStatus'
];

export const organizationEscalationExtraFields = [
  'relatedOrganizationTask.labelDetails.name',
  'relatedOrganizationTask.labelDetails.color',
  'relatedOrganizationTask.labelIds',
  'relatedOrganizationTask.entityCachedData.detectionDate',
  'relatedTaskIds',
  'organization.companyName',
  'organization.id',
  'createdBy',
  'createdByUser.name',
  'createdByUser.picture',
  'createdAt',
  'escalatedTo.id',
  'escalatedTo.type',
  'reason'
];

export const escalationExtraFields = [
  'relatedActiveTasks.entityCachedData.payment.id',
  'relatedActiveTasks.entityCachedData.payment.amount',
  'relatedActiveTasks.entityCachedData.payment.currency',
  'relatedActiveTasks.prioritization',
  'relatedTaskIds',
  'relatedTasks.entityId',
  'organization.companyName',
  'createdBy',
  'createdByUser.name',
  'createdByUser.picture',
  'createdAt',
  'escalatedTo.id',
  'escalatedTo.type',
  'reason'
];

export const sherlockOrganizationExtraFields = [
  'partner.companyName',
  'partner.partnerName',
  'relatedTasksNum',
  'detectionDate',
  'zendeskTickets.id',
  'zendeskTickets.latestComment.status',
  'zendeskTickets.latestComment.createdAt',
  'zendeskTickets.latestComment.commenter.isAnalyst',
  'zendeskTickets.latestComment.commenter.name'
];
